<div class="matero-page-header-inner">
  <h1 class="matero-page-title">
    {{ title | translate }} <small>{{ subtitle }}</small>
  </h1>
  <breadcrumb *ngIf="showBreadCrumb" [nav]="nav"></breadcrumb>
</div>
